import * as R from "ramda";
import {createReducer} from "./index";

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  ACTIONS  //////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

export const SET_ITEM = 'SET_ITEM';
export const SET_POSITION = 'SET_POSITION';
export const SET_VISIBLE = 'SET_VISIBLE';

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////  ACTION CREATORS  //////////////////////////////
////////////////////////////////////////////////////////////////////////////////

export const setItem = name => ({type: SET_ITEM, payload: name });
export const setPosition = ({x = 0, y = 0}) => ({type: SET_POSITION, payload: {x, y}});
export const setVisible = visible => ({type: SET_VISIBLE, payload: visible});

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  THUNKS  //////////////////j////////////////
////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  REDUCER  //////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

const initialState = {
  item: null,
  visible: false,
  position: {x: 0, y: 0},
};

export const hintReducer = createReducer(initialState, {
  // [ACTION_TYPE]: (state, action) => state,
  [SET_ITEM]: (state, action) => R.set(R.lensPath(['item']), action.payload)(state),
  [SET_POSITION]: (state, action) => R.set(R.lensPath(['position']), action.payload)(state),
  [SET_VISIBLE]: (state, action) => R.set(R.lensPath(['visible']), action.payload)(state),
});
